import styled from 'styled-components';
import { Row, Typography } from 'antd';
import { Footer } from 'antd/lib/layout/layout';

import { baseStyle } from 'components/Layout/styles';
import { Markdown, MarkdownProps } from 'components';

export const LogoRow = styled(Row)`
  margin-top: 0.5rem;
  margin-bottom: 24px;
`;

export const StyledFooter = styled(Footer)`
  ${baseStyle}
  background-color: #4b4f53;
  color: var(--text-color-invert);
`;

export const SectionHead = styled(Typography.Text)`
  color: inherit;
  // margin-bottom: 1.5rem;
  margin-bottom: 1rem;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

// Note(Anson Kan): to unset the default `p` margin
const ZeroMarginP = styled.p`
  margin: 0;
`;

const NormalA = styled.a`
  color: inherit;
  text-decoration: underline;
`;

const customMarkdownComponents: MarkdownProps['components'] = {
  p: ({ node, ...props }) => {
    return <ZeroMarginP {...props} />;
  },
  a: ({ node, ...props }) => {
    return <NormalA {...props} />;
  },
};

export const CustomMarkdown = ({ components, ...others }: MarkdownProps): JSX.Element => (
  <Markdown components={customMarkdownComponents} {...others} />
);
